"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SystemTile = require("@ccw-pwa-ui/SystemTile");
var _react = _interopRequireDefault(require("react"));
var _SubNavHeading = require("@ccw-pwa-ui/SubNavHeading");
var _Modal = require("@ccw-pwa-ui/Modal");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _AlertTileComponent = require("@ccw-pwa-ui/AlertTileComponent");
var _SystemAccessoryComponent = _interopRequireDefault(require("./SystemAccessoryComponent"));
var _helper = require("../common_features/utility/helper");
require("../styles/SystemDetailComponentStyle.css");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _Button = require("@ccw-pwa-ui/Button");
var _StoreInformationTile = require("@ccw-pwa-ui/StoreInformationTile");
const SystemDetailComponent = _ref => {
  let {
    systemDetails,
    systemAccessoryDetail,
    heading,
    subHeading,
    separator,
    handleBack,
    systemDetail,
    systemImage,
    systemName,
    systemPartNumber,
    installedText,
    installedDate,
    questionIcon,
    aboutText,
    statusText,
    alertImage,
    alertText,
    plusIcon,
    editWaterIcon,
    editWaterText,
    editWaterInfoFlag,
    sensorText,
    handleOnClickEditWaterInfo,
    editPhotoClicked,
    accessoryText,
    completeSystemText,
    systemAccessoryImage,
    handleOnClickEditWater,
    leftArrow,
    backNavigationScreen,
    alertStyle,
    waterDestinationItem,
    part,
    installedDateText,
    filterLifeText,
    editImageRight,
    isArrowImageVisible,
    isEditVisible,
    onClickArrowRight,
    handleOnClickSensor,
    isLoading,
    statusLevelImage,
    statusLevelText,
    alertData,
    alertOkText,
    alertOkImage,
    onClickAlert,
    storeId,
    handleRemoveSysBtn,
    removeSysBtn,
    warningSystemModalData,
    warningSystemModal,
    openSystemErrorModal,
    handleAboutText,
    aboutTextModalData,
    aboutTextModal,
    handleOnClickAddAccessory,
    onClickSystemArrow,
    isContinueVisible,
    handlePartialContinue,
    partialLogo,
    currentPage,
    totalPage,
    pencilIcon,
    editTextRight,
    arrowIcon,
    store,
    handleClick,
    isPartial,
    addImageIcon
  } = _ref;
  const getFilterDateChange = filter => {
    if (filter.refAppType !== "Accessory") {
      var newDate = new Date(filter === null || filter === void 0 ? void 0 : filter.refAppInstallationDate);
      newDate.setMonth(newDate.getMonth() + (filter === null || filter === void 0 ? void 0 : filter.selectedRefAppLife));
      newDate.setDate(newDate.getDate() + 1);
      return (0, _helper.getDate)(newDate.toISOString());
    }
  };
  const getRefAppLifeStatusSubStyle = system => {
    return (system === null || system === void 0 ? void 0 : system.refAppLifeStatus) === 1 ? /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
      headerStyle: {
        fontSize: 27,
        color: "#FA6400",
        fontWeight: 600,
        marginLeft: "10px"
      },
      variant: "header-text",
      headerText: "Medium"
    }) : /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
      headerStyle: {
        fontSize: 27,
        color: "rgb(224, 9, 50)",
        fontWeight: 600,
        marginLeft: "10px"
      },
      variant: "header-text",
      headerText: "Low"
    });
  };
  const getRefAppLifeStatusStyle = system => {
    return (system === null || system === void 0 ? void 0 : system.refAppLifeStatus) === 0 ? /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
      headerStyle: {
        fontSize: 27,
        color: "#4F8309",
        fontWeight: 600,
        marginLeft: "10px"
      },
      variant: "header-text",
      headerText: "Good"
    }) : getRefAppLifeStatusSubStyle(system);
  };
  const getRefAppLifeForMedium = system => {
    return (system === null || system === void 0 ? void 0 : system.refAppLifeStatus) === 1 ? _index.default.mediumLevel.default : _index.default.lowFilter.default;
  };
  const getRefAppLifeForGood = system => {
    return (system === null || system === void 0 ? void 0 : system.refAppLifeStatus) === 0 ? _index.default.goodLevel.default : getRefAppLifeForMedium(system);
  };
  const getAlertTile = () => {
    return isContinueVisible ? /*#__PURE__*/_react.default.createElement(_AlertTileComponent.AlertTileComponent, {
      alertOkText: alertText,
      alertOkImage: alertImage
    }) : /*#__PURE__*/_react.default.createElement(_AlertTileComponent.AlertTileComponent, {
      alertOkText: "Incomplete Setup",
      alertOkImage: partialLogo,
      variant: "Incomplete_System"
    });
  };
  return isLoading ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "system-detail-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_SubNavHeading.SubNavHeading, {
    heading: heading,
    subHeading: subHeading,
    separator: separator
  }), /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: backNavigationScreen,
    handleBack: handleBack,
    leftArrowImage: _index.default.leftArrow.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "system-detail-body"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_SystemAccessoryComponent.default, {
    systemImage: systemImage,
    systemName: systemName,
    systemPartNumber: systemPartNumber,
    installedText: installedText,
    installedDate: installedDate,
    questionIcon: questionIcon,
    aboutText: aboutText,
    system: systemAccessoryDetail,
    waterDestinationItem: waterDestinationItem,
    handleAboutText: handleAboutText,
    aboutTextModalData: aboutTextModalData,
    aboutTextModal: aboutTextModal,
    isArrowImageVisible: isArrowImageVisible,
    arrowImageRight: editImageRight,
    onClickSystemArrow: onClickSystemArrow,
    editTextRight: editTextRight
  }), editWaterInfoFlag ? /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-water-photos-text"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "outer-div-text",
    onClick: handleOnClickEditWaterInfo
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: editWaterIcon,
    className: "edit-icon",
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-water-info-text"
  }, "Edit Water Info")), /*#__PURE__*/_react.default.createElement("div", {
    className: "seperator"
  }), /*#__PURE__*/_react.default.createElement("div", {
    onClick: editPhotoClicked,
    style: {
      display: 'flex',
      cursor: 'pointer'
    },
    "data-testid": "edit-clicked"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: addImageIcon,
    className: "edit-icon",
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-water-info-text"
  }, "Edit Photos"))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null), isPartial && /*#__PURE__*/_react.default.createElement("div", {
    className: "service_tile"
  }, /*#__PURE__*/_react.default.createElement(_StoreInformationTile.StoreInformationTile, {
    name: store,
    onClick: handleClick,
    arrowImage: arrowIcon,
    rightButtonShow: true,
    infoContainerStyle: {
      maxWidth: '1030px',
      height: '58px',
      border: '1px solid #EBEBEB',
      padding: '12px, 16px, 12px, 16px',
      boxShadow: ' 0px 2px 0px 0px #EBEBEB'
    }
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 13,
      color: "black",
      fontWeight: 700,
      marginLeft: "22px"
    },
    variant: "header-text",
    headerText: statusText
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(alertData !== null && alertData !== void 0 && alertData.length ? "alert-tile-container-wrapper" : "alert-tile-container-wrapper-withoutLength"),
    "data-testid": "system_alert_tile"
  }, isContinueVisible && alertData !== null && alertData !== void 0 && alertData.length ? alertData.map(item => {
    return /*#__PURE__*/_react.default.createElement(_AlertTileComponent.AlertTileComponent, {
      key: item.alertMessageType,
      alertImage: item.alertImageLeft,
      alertText: item.alertText,
      alertTextStyle: (0, _helper.setAlarmSeverityColor)(item.alertMessageType),
      isAlert: true,
      alertImageRight: _index.default.smallArrow.default,
      onClickAlert: e => onClickAlert({
        id: item.id,
        storeId,
        ...item
      })
    });
  }) : getAlertTile())), isEditVisible && isContinueVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-sensor-accessory-text"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "outer-div-text outer-right-border",
    onClick: handleOnClickEditWater
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: pencilIcon,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-water-text"
  }, editWaterText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "outer-div-text",
    onClick: handleOnClickAddAccessory
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: plusIcon,
    className: "plus-icon",
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-text"
  }, accessoryText))), isContinueVisible ? /*#__PURE__*/_react.default.createElement("div", {
    className: "completeHeaderText"
  }, completeSystemText) : null, !isContinueVisible ? /*#__PURE__*/_react.default.createElement("div", {
    className: "breakLine"
  }) : null, !isContinueVisible ? /*#__PURE__*/_react.default.createElement("div", {
    className: "stepClass"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "currentStep"
  }, "Step ", currentPage), /*#__PURE__*/_react.default.createElement("span", {
    className: "totalStep"
  }, "of ", totalPage, " Completed")) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "system-map-tile-wrapper"
  }, systemDetails === null || systemDetails === void 0 ? void 0 : systemDetails.map(system => /*#__PURE__*/_react.default.createElement(_SystemTile.SystemTile, {
    system: system,
    part: part,
    key: system.refAppName,
    accessoryImageUrl: system.refAppImageUrl ? system.refAppImageUrl : _index.default.noImg.default,
    accessoryName: system === null || system === void 0 ? void 0 : system.refAppModelNumber,
    accessoryType: system.refAppName === "Sensor" ? system.refAppPlacement : system.refAppName,
    accessoryPartNumber: system.refAppPartNumber,
    accessoryLife: system.refAppType === "Replacement Part" ? (0, _helper.remainingFilterLife)(system.selectedRefAppLife, system.refAppInstallationDate) : null,
    statusLevelImage: system.refAppType === "Replacement Part" ? getRefAppLifeForGood(system) : null,
    statusLevelText: system.refAppType === "Replacement Part" ? getRefAppLifeStatusStyle(system) : null,
    installedDateText: installedDateText,
    filterLifeText: system.refAppType === "Replacement Part" ? filterLifeText : null,
    installedDate: (0, _helper.getDate)(system.refAppInstallationDate),
    arrowImageRight: editImageRight,
    editTextRight: editTextRight,
    editStyle: {
      flexDirection: 'column',
      fontFamily: 'Poppins',
      fontSize: '13px',
      fontWeight: '700',
      lineHeight: '20px',
      color: '#006E96',
      margin: '5px'
    },
    editContainer: "outer-div-edit-text",
    isArrowImageVisible: isArrowImageVisible,
    onClickArrowRight: () => {
      onClickArrowRight(system.refAppName, system, system.refAppType);
    },
    filterDateChangeText: "Recommended ".concat(system.refAppType === "Accessory" ? "Accessory" : "filter", " change date"),
    filterDateChange: getFilterDateChange(system),
    filterParts: system.refAppType === "Accessory" ? false : true
  })))), !isContinueVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: "partial-continue-btn",
    "data-testid": "partial-event"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: "Continue",
    onClick: handlePartialContinue,
    disabled: false
  })), isEditVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: "remove-system-btn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outline-primary-long",
    title: "Remove System",
    onClick: handleRemoveSysBtn,
    disabled: removeSysBtn
  }))), (warningSystemModal || openSystemErrorModal) && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.displayModal,
    modalHeaderText: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.modalHeaderText,
    modalHeaderTextStyle: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.modalHeaderTextStyle,
    modalDetailText: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.modalDetailText,
    modalHeaderIcon: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.modalHeaderIcon,
    displayCrossIcon: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.displayCrossIcon,
    variant: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.variant,
    positiveActionButtonTitle: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.positiveActionButtonTitle,
    positiveAction: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.positiveAction,
    negativeButtonActionTitle: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.negativeButtonActionTitle,
    crossIconAction: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.crossIconAction,
    negativeAvtion: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.negativeAvtion
  }));
};
var _default = exports.default = SystemDetailComponent;